<template>
	<span :class="labelClass">{{ prioritaLabel }}</span>
</template>

<script>
export default {
	props: {
		prioritaLabel: {
			type: String,
			default: () => {
				return "";
			},
		},
	},
	computed: {
		labelClass() {
			return this.prioritaLabel ? "sa-priorita-color-" + this.prioritaLabel.toLowerCase() : "";
		},
	},
};
</script>

<style>
.sa-priorita-color-normale {
	color: #020202;
}
.sa-priorita-color-media {
	color: #00aeff;
}
.sa-priorita-color-alta {
	color: #fbb000;
}
.sa-priorita-color-urgente {
	color: red;
}
</style>
